/* eslint-disable react-hooks/exhaustive-deps */
import React,{useEffect, useState, useCallback, useRef, useMemo} from 'react';
import { Dialog, DialogActionsBar} from '@progress/kendo-react-dialogs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalculator, faCalendar, faCalendarAlt, faFaceFrown, faFaceSmile, faFileExcel, faPlus, faRedoAlt, faSquare, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Button, Toolbar } from '@progress/kendo-react-buttons';
import { TabStrip, TabStripTab, TabStripSelectEventArguments } from '@progress/kendo-react-layout';
import { Grid, GridColumn, GridNoRecords, GridToolbar } from '@progress/kendo-react-grid';
import { DatePicker} from "@progress/kendo-react-dateinputs";
import { Loader, LoaderType } from '@progress/kendo-react-indicators';
import { ConfirmDialog } from './confirmation';
import { Input, Switch } from '@progress/kendo-react-inputs';
import { process, State } from '@progress/kendo-data-query';
import { getSelectedState } from '@progress/kendo-react-data-tools';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { ExcelExport } from '@progress/kendo-react-excel-export';
import { filterBy } from '@progress/kendo-data-query';
 
//Manage program area reservations

const WalkInForm=({type, areaId, onClose, date})=>{
    const [lookupId, setLookupId]=useState("");
    const [lookupName, setLookupName]=useState("");
    const [searchField,setSearchField]=useState("id");
    const [data, setData]=useState([]);
    const [select,setSelect]=useState(undefined);
    const [selTimeBlock, setSelTimeBlock]=useState(undefined);
    const [resBlocks, setResBlocks]=useState([]);
    const [resExists,setResExists]=useState(false);

    const getResBlocks = async ()=>{
        const year = ''+date.getFullYear();
        let month = ''+(date.getMonth()+1);
        let day = ''+date.getDate();
        if (month.length<2){
            month = "0" +month;
        }
        if (day.length<2){
            day = "0"+day;
        }
        const dtParam = [year,month,day].join("-");
        const params=new URLSearchParams({area:areaId, date:dtParam});
        const url= "api/index.php/program/getAvailableBlocks?" + params;
        fetch (url,{
            method:"GET"
        }).then(response=>response.json()).then(async data=> {
            console.log(data);
            setResBlocks(data);
        })
    }

    const getParticipant = async ()=>{
        console.log(lookupId);
        console.log(lookupName);
        const params=new URLSearchParams({id:lookupId, name:lookupName});
        const url= "api/index.php/program/getParticipant?" + params;
        fetch (url,{
            method:"GET"
        }).then(response=>response.json()).then(async data=> {
            console.log(data);
            setData(data);
        })
    }

    const addToQueue=()=>{
        const tmdt = date.toISOString().split('T')[0];
        console.log("Make Reservation: " + areaId + " " + tmdt);
        const postData = new FormData();
        const id = Object.keys(select)[0];
        const url= "api/index.php/program/insertReservation";
        postData.append("id",id);
        postData.append("areaId",areaId);
        postData.append("date",tmdt);
        fetch (url,{
            method:"POST",
            body:postData
        }).then(response=>response.json()).then(async data=> {
            console.log(data);
            if (data==0){
                setResExists(true);
            }
            onClose();
        })
    }

    const addReservation=()=>{
        let BlockRes=[];
        const selId = Object.keys(select)[0]
        const newBlockRes = {
            AreaId:areaId,
            ParticipantId:selId,
            BlockId:selTimeBlock.BlockId,
            Complete:0,
            Type:'manual'
        }
        BlockRes.push(newBlockRes);
        console.log(BlockRes);
        const jsonString = JSON.stringify(BlockRes);
        console.log(jsonString);
        //const postData = new FormData();
        const url= "api/index.php/program/insertBlockReservation";
       // postData.append("data",jsonString);
        fetch (url,{
            method:"POST",
            headers:{"Content-Type":"application/json"},
            body:jsonString
        }).then(response=>{
            console.log(response);
            if (response.status=="200"){
                response.json().then(data=>{
                    console.log(data);
                    onClose();
                });
            }
        })
    }

    const clearLast=()=>{
        setLookupName("");
    }

    const clearId=()=>{
        setLookupId("");
    }

    const onFieldSwitchChange=(e)=>{
        if (e.value===true){
            setSearchField("id");
            clearLast();
        }else{
            setSearchField("name");
            clearId();
        }
    }
    const searchValueChange=(e)=>{
        if (searchField==="id"){
            setLookupId(e.value);
        }else{
            setLookupName(e.value);
        }
    }

    const onParticipantSelection=(event)=>{
        console.log(event.select)
        setSelect(event.select);
    }

    const onBlockSelection=(event)=>{
      //  console.log("Foo");
      setSelTimeBlock(event.value);
    }

    const customItemRender = (li, itemProps) => {
    const itemData = itemProps.dataItem;
    
        // Clone the default <li> element but insert custom text structure
        return React.cloneElement(
            li,
            li.props,
            <span>{itemData.Date} — <strong>{itemData.StartTime}</strong></span>
        );
    };

    const valueItemRender = (item, props) => {
    if (!item) {
      return <span>Select a time block</span>;
    }
    return (
      <span>
        {item.Date} - {item.StartTime}
      </span>
    );
  };

    const customValueRender = (element, value) => {
        if (!value) {
        return element; // Fallback to default placeholder if no value is chosen
        }
        
        // Replace the default element child text with your own string format
        return React.cloneElement(element, {
        ...element.props,
        children: `${value.Date} ${value.StartTime}`
        });
    };


    useEffect(()=>{
        console.log(type);
        console.log(areaId);
        console.log(date);
        getResBlocks();
    },[])

    return(
        <>
        <Dialog title={type==="reservation"?"Add Reservation":"Add To Lottery"} onClose={onClose} width={"40vw"}>
            {type==="reservation"?
            <DropDownList
                data={resBlocks}
                field={"BlockId"}
                textField='BlockId'
                dataItemKey='BlockId'
                label='Select Time Block'
                itemRender={customItemRender}
                valueRender={customValueRender}
                style={{width:"100%", marginBottom:"10px"}}
                fillMode="outline"
                onChange={onBlockSelection}
            />
            :null}
            <div style={{ width:"100%", marginTop:"10px", marginBottom:"10px"}}><Switch checked={searchField==="id"?true:false} onLabel="" offLabel="" onChange={onFieldSwitchChange}/> <label>Search by: {searchField==="id"?"Member Id":"Last Name"}</label></div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}><Input onChange={searchValueChange}/><Button onClick={getParticipant}>Search</Button></div>
            {data.length>0?
            <div style={{ width:"100%", marginTop:"10px", marginBottom:"10px"}}><Grid
                data={data}
                dataItemKey='MemberId'
                select={select}
                selectable={{ enabled: true, drag: false, cell: false, mode: 'single' }}
                selectedField={'selected'}
                onSelectionChange={onParticipantSelection}
            >
                <GridColumn field="selected" width="50px" columnType='checkbox' />
                <GridColumn field='NameLast' title='Last'/>
                <GridColumn field='NameFirst' title='First'/>
                <GridColumn field='CouncilName' title='Council'/>
                <GridColumn field='Contingent' title='Contingent'/>
                <GridColumn field='EventAge' title='Age'/>
            </Grid></div>
            :null}
            {type=="reservation"?
                selTimeBlock!=undefined && select!=undefined?
                    <DialogActionsBar>
                        <Button themeColor='primary' onClick={addReservation}>Save</Button>
                        <Button onClick={onClose}>Cancel</Button>
                    </DialogActionsBar>        
                :null
            :
                select!=undefined?
                    <DialogActionsBar>
                        <Button themeColor='primary' onClick={addToQueue}>Save</Button>
                        <Button onClick={onClose}>Cancel</Button>
                    </DialogActionsBar>        
                :null
            }
        </Dialog>
        </>
    )
}

const ChangeForm=({areaId, onClose, onSave})=>{
    const [resBlocks, setResBlocks]=useState([]);
    const [selTimeBlock, setSelTimeBlock]=useState(undefined);

    const getResBlocks = async ()=>{
        //const dtParam = [year,month,day].join("-");
        const params=new URLSearchParams({area:areaId, date:""});
        const url= "api/index.php/program/getAvailableBlocks?" + params;
        fetch (url,{
            method:"GET"
        }).then(response=>response.json()).then(async data=> {
            console.log(data);
            setResBlocks(data);
        })
    }

    const customItemRender = (li, itemProps) => {
    const itemData = itemProps.dataItem;
    
        // Clone the default <li> element but insert custom text structure
        return React.cloneElement(
            li,
            li.props,
            <span>{itemData.Date} — <strong>{itemData.StartTime}</strong></span>
        );
    };

    const valueItemRender = (item, props) => {
    if (!item) {
      return <span>Select a time block</span>;
    }
    return (
      <span>
        {item.Date} - {item.StartTime}
      </span>
    );
  };

    const customValueRender = (element, value) => {
        if (!value) {
        return element; // Fallback to default placeholder if no value is chosen
        }
        
        // Replace the default element child text with your own string format
        return React.cloneElement(element, {
        ...element.props,
        children: `${value.Date} ${value.StartTime}`
        });
    };

    const onBlockSelection=(event)=>{
      //  console.log("Foo");
      setSelTimeBlock(event.value);
    }

    useEffect(()=>{
        onSave(selTimeBlock);
    },[selTimeBlock])

    useEffect(()=>{
        getResBlocks();
    },[])

    return(
        <>

        <Dialog title={"Change Reservation"} onClose={onClose} width={"30vw"}>
            <p>You are changing the scheduled time block for the selected reservations. Proceed with caution!</p>
            <DropDownList
                data={resBlocks}
                field={"BlockId"}
                textField='BlockId'
                dataItemKey='BlockId'
                label='Select Time Block'
                itemRender={customItemRender}
                valueRender={customValueRender}
                style={{width:"100%", marginBottom:"10px"}}
                fillMode="outline"
                onChange={onBlockSelection}
            />
        </Dialog>
        </>
    )
}



const ReservationQueue=({areaId,lotteryState,updateLotteryState})=>{
    const [data,setData]=useState([]);
    const [lottery,setLottery]=useState([]);
    const [resBlocks, setResBlocks]=useState([]);
    const [showWalkIn, setShowWalkIn]=useState(false);

    const activeArea = areaId;
    const [tomorrow,setTomorrow]=useState();
    const [waiting, setWaiting]=useState(false);
    const lockResults=()=>{
        console.log("Lock Results");
        showWaiting();
        getResBlocks();
    }

    const showWaiting =()=>{
        setWaiting(true);
    }

    const hideWaiting=()=>{
        setWaiting(false);
    }

     const closeWalkIn=()=>{
        setShowWalkIn(false);
        getResQueue();
    }

    const openWalkIn=()=>{
        setShowWalkIn(true);
    }


    const getResBlocks = async ()=>{
        
        let dtParam = "";
        lottery.forEach(item=>{
            dtParam=item.Date;
        })
        const params=new URLSearchParams({area:areaId, date:dtParam});
        const url= "api/index.php/program/getAvailableBlocks?" + params;
        fetch (url,{
            method:"GET"
        }).then(response=>response.json()).then(async data=> {
            setResBlocks(data);
        })
    }

    const fillResBlocks=()=>{
        let BlockRes=[];
        console.log("Fill Res Blocks");
        console.log(lottery);
        let lotteryIndex=0;
        resBlocks.forEach(block=>{
            const cap=Number(block.Capacity-block.filled);
            const blockId=block.BlockId;
            for (let i=0; i<cap; i++){
                console.log(lottery[lotteryIndex]);
                if (lottery[lotteryIndex]!=undefined){
                    const newBlockRes = {
                        AreaId:activeArea,
                        ParticipantId:lottery[lotteryIndex].AttendeeID,
                        BlockId:blockId,
                        Complete:0,
                        Type:"lottery"
                    }
                    BlockRes.push(newBlockRes);
                    lotteryIndex++;
                }
            } 
        })
        console.log(BlockRes);
        const jsonString = JSON.stringify(BlockRes);
        console.log(jsonString);
        //const postData = new FormData();
        const url= "api/index.php/program/insertBlockReservation";
       // postData.append("data",jsonString);
        fetch (url,{
            method:"POST",
            headers:{"Content-Type":"application/json"},
            body:jsonString
        }).then(response=>{
            console.log(response);
            if (response.status=="200"){
                response.json().then(data=>{
                    console.log(data);
                    completeLottery();
                });
            }
        })
    }

    const completeLottery=()=>{
        const year = ''+tomorrow.getFullYear();
        let month = ''+(tomorrow.getMonth()+1);
        let day = ''+tomorrow.getDate();
        if (month.length<2){
            month = "0" +month;
        }
        if (day.length<2){
            day = "0"+day;
        }
        const dtParam = [year,month,day].join("-");
       

        const url= "api/index.php/program/insertUpdateLotteries";
       // postData.append("data",jsonString);
        const area = areaId;
         const payload = {
            areaId:area,
            date:dtParam,
            complete:1
        }
        console.log(payload)
        fetch (url,{
            method:"POST",
            headers:{"Content-Type":"application/json"},
            body:JSON.stringify(payload)
        }).then(response=>{
            response.json().then(async data=> {
                console.log("Lottery results saved");
                console.log(data);
                hideWaiting();
                if (data.complete==1){
                    updateLotteryState(true);
                }
            });
        });
    }

    const getLotteryResults = async ()=>{
        console.log(areaId);
        console.log(tomorrow);
        const year = ''+tomorrow.getFullYear();
        let month = ''+(tomorrow.getMonth()+1);
        let day = ''+tomorrow.getDate();
        if (month.length<2){
            month = "0" +month;
        }
        if (day.length<2){
            day = "0"+day;
        }
        const dtParam = [year,month,day].join("-");
        const params=new URLSearchParams({area:areaId,date:dtParam});
        const url= "api/index.php/program/getLotteryResults?" + params;
        fetch (url,{
            method:"GET"
        }).then(response=>response.json()).then(async data=> {
            setLottery(data);
        })
    }

    const getResQueue = async ()=>{
        if (tomorrow){

        console.log(tomorrow);
        console.log(areaId);
        const year = ''+tomorrow.getFullYear();
        let month = ''+(tomorrow.getMonth()+1);
        let day = ''+tomorrow.getDate();
        if (month.length<2){
            month = "0" +month;
        }
        if (day.length<2){
            day = "0"+day;
        }
        const dtParam = [year,month,day].join("-");
        const params=new URLSearchParams({area:areaId, date:dtParam});
        const url= "api/index.php/program/getResQueue?" + params;
        fetch (url,{
            method:"GET"
        }).then(response=>response.json()).then(async data=> {
            setData(data);
        })
        }
    }



    const ChangedRow = useCallback((props) => {
        const { dataItem } = props;
        let rowClassName = '';
        if (lottery && lottery.length>0){
            if (dataItem && dataItem.isChanged) {
                rowClassName = 'changed-row'; 
            }       
            const isChanged = lottery.find(item=>String(item.AttendeeID)===String(dataItem.AttendeeId));
            // console.log(isChanged);
            if (isChanged){
                rowClassName='changed-row';
            }
        }
    // Merge the custom class with Kendo's default row props
    return <tr {...props} className={`${props.className} ${rowClassName}`} />;
    }, [lottery]);

    const getTomorrow = ()=>{
        let tmro = new Date();
        const day1 = new Date(2026,6,23);
        tmro.setDate(tmro.getDate() + 1);
        if (tmro< day1){
            tmro=new Date(day1);
        }
        return (tmro);
    }


    useEffect(()=>{
        console.log(resBlocks);
        if (resBlocks.length>0){
            fillResBlocks();
        }
    },[resBlocks])

    useEffect(()=>{
        getResQueue();
    },[tomorrow])

    useEffect(()=>{
        console.log("Lottery State");
        console.log(lotteryState);
    },[lotteryState])

    useEffect(()=>{
        const tmro =getTomorrow();
        setTomorrow(tmro);
    },[])

    return(
        <>
        {showWalkIn?<WalkInForm areaId={areaId} type={"queue"} onClose={closeWalkIn} date={tomorrow}/>:null}
        {waiting?
            <Dialog title="Please Wait" modal={true} onClose={() => {}}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px' }}>
                <p>Updating the program reservations with the lottery results. Please do not close this window.</p>
                <Loader type="converging-spinner" size="large" />
            </div>
            </Dialog>
        :null}
        <DatePicker 
            min={new Date(2026,6,23)}
            max={new Date(2026,6,30)}
            value={tomorrow}
            format={"EEEE MMM d, y"}
        />
        {data.length>0?<h2>Reservation request queue for {data[0].date}. Total requests {data.length}</h2>:null}
        {lottery && lottery.length>0?<h2>{lottery.length} of {data.length} records selected. Lottery winners are highlighted. Click SAVE RESULTS to finalize today's lottery</h2>:null}
        
        <Grid
            data={data}
            rows={{data:ChangedRow}}
        >            
            <GridToolbar>
                {lotteryState===false?<Button onClick={getLotteryResults}>Run Daily Lottery</Button>:null}
                <Button title='Add Walk-In' onClick={openWalkIn}><FontAwesomeIcon icon={faPlus}/> Add To Lottery</Button>

                {lotteryState===false?lottery && lottery.length>0?<Button onClick={lockResults}>Save Results</Button>:null:null}
            </GridToolbar>
            <GridColumn field='date' title='Date'/>
            <GridColumn field='AttendeeId' title='Id' />
            <GridColumn field="NameLast" title='Last' media="(min-width: 768px)"/>
            <GridColumn field='NameFirst' title='First' media="(min-width: 768px)"/>
        </Grid>
        </>
    )
}

const Reservations=({areaId,date,checkIn})=>{
    const [data,setData]=useState([]);
    const activeArea = areaId;
    const [tomorrow,setTomorrow]=useState();
    const [selectedState, setSelectedState] = useState({});
    const [showWalkIn, setShowWalkIn]=useState(false);
    const [showChange, setShowChange]=useState(false);
    const [showChangeButton,setShowChangeButton]=useState(false);
    const today = new Date()
    const getResList = async ()=>{
        if (tomorrow){
            console.log(tomorrow);
            console.log(areaId);
            const year = ''+tomorrow.getFullYear();
            let month = ''+(tomorrow.getMonth()+1);
            let day = ''+tomorrow.getDate();
            if (month.length<2){
                month = "0" +month;
            }
            if (day.length<2){
                day = "0"+day;
            }
            const dtParam = [year,month,day].join("-");
            const params=new URLSearchParams({area:areaId, date:dtParam});
            const url= "api/index.php/program/getResList?" + params;
            fetch (url,{
                method:"GET"
            }).then(response=>response.json()).then(async data=> {
                setData(data);
            })
        }
    }

    const getTomorrow = ()=>{
        let tmro = new Date();
        const day1 = new Date(2026,6,23);
        tmro.setDate(tmro.getDate() + 1);
        if (tmro< day1){
            tmro=new Date(day1);
        }
        return (tmro);
    }

    const getAllSelectedRows = () => {
        return data.filter(item => selectedState[item["ParticipantId"]]);
    };

    const CheckedIn = useCallback((props) => {
        const { dataItem } = props;
        let rowClassName = '';
        switch(dataItem.Complete){
            case 1:
                rowClassName="stage-1-checkin";
                break;
            case 2:
                rowClassName="stage-2-checkin";
                break;
            default:
                rowClassName="";
                break;
        }
        // Merge the custom class with Kendo's default row props
        return <tr {...props} className={`${props.className} ${rowClassName}`} />;
    },[data]);

    const changeDate=(e)=>{
        const newDate = e.value;
        setTomorrow(newDate);
    }

    const onSelectionChanged=(event)=>{
        console.log("Selected");
        const newSelectedState = getSelectedState({
            event,
            selectedState,
            dataItemKey:"ParticipantId"
        });
        console.log(newSelectedState);
        setSelectedState(newSelectedState);
    }



    const onChangeRes=(selTimeBlock)=>{
        if (selTimeBlock!=undefined){
            console.log(selTimeBlock);
            //console.log("Update block to " + selTimeBlock.BlockId);
            const selectedRows = getAllSelectedRows();
            selectedRows.forEach(item=>{
                const postData = new FormData();
                const url= "api/index.php/program/changeReservation";
                postData.append("id",item.ParticipantId);
                postData.append("area",areaId);
                postData.append("block",item.BlockId);
                postData.append("newBlock",selTimeBlock.BlockId);
                fetch (url,{
                    method:"POST",
                    body:postData
                }).then(response=>response.json()).then(async data=> {
                    console.log(data);
                    if (data>0){
                        console.log("Changed");
                        closeChange();
                        getResList();
                        setSelectedState({});
                    }
                })

            });
        }

    }

    const closeWalkIn=()=>{
        setShowWalkIn(false);
        getResList();
    }

    const openWalkIn=()=>{
        setShowWalkIn(true);
    }

    const closeChange=()=>{
        console.log("Foo");
        setShowChange(false);
        //getResList();
    }

    const openChange=()=>{
        setShowChange(true);
    }

    const [filter, setFilter] = useState({
        logic: 'and',
        filters: []
    });

    const filteredData = useMemo(
        () => filterBy(data, filter),
        [data, filter]
    );


    useEffect(()=>{
        getResList();
    },[tomorrow])

    useEffect(()=>{
        console.log(data);
    },[data])

    useEffect(()=>{
        if (Object.keys(selectedState).length>0){
            setShowChangeButton(true);
        }else{
            setShowChangeButton(false);
        }
    },[selectedState])
    
    useEffect(()=>{
        //set the default date to tomorrow.
        const tmro =getTomorrow();
        setTomorrow(tmro);
    },[])

    const _export = useRef(null);
    const excelExport = () => {
        if (_export.current !== null) {
            _export.current.save();
        }
    };

    return(
        <>
        {showWalkIn?<WalkInForm areaId={areaId} type={"reservation"} onClose={closeWalkIn} date={tomorrow}/>:null}
        {showChange?<ChangeForm areaId={areaId} onClose={closeChange} onSave={onChangeRes}/>:null}

        <DatePicker 
            min={new Date(2026,6,23)}
            max={new Date(2026,6,30)}
            value={tomorrow}
            format={"EEEE MMM d, y"}
            onChange={changeDate}
        />
        {checkIn===2?<div ><span style={{color:"orange"}}><FontAwesomeIcon icon={faSquare}/></span> Checked in at welcome area</div>:null}<div ><span style={{color:"green"}}><FontAwesomeIcon icon={faSquare}/></span> Final check in</div>
        <ExcelExport data={filteredData} ref={_export}>
        <Grid
            data={data}
            autoProcessData={true}
            filterable={true}
            filter={filter}
            onFilterChange={(e) => setFilter(e.filter)}
            rows={{data:CheckedIn}}
            dataItemKey='ParticipantId'
            selectable={{
                enabled: true,
                drag: false,
                cell: false,
                mode: 'multiple'
            }}
            select={selectedState}
            selectedField="selected"
            onSelectionChange={onSelectionChanged}
            >
            <GridNoRecords>
                <div><strong>The lottery has not been run yet.</strong></div>
            </GridNoRecords>
            <GridToolbar>
                {showChangeButton?<Button title='Move Reservation' onClick={openChange}><FontAwesomeIcon icon={faCalendarAlt}/> Change Reservation</Button>:<div/>}
                <Button title='Add Walk-In' onClick={openWalkIn}><FontAwesomeIcon icon={faPlus}/> Add Walk-In</Button>
                <Button title='Refresh' onClick={getResList}><FontAwesomeIcon icon={faRedoAlt}/> Refresh</Button>
                <Button title="Export Excel" type="button" onClick={excelExport}><FontAwesomeIcon icon={faFileExcel}/>Export</Button>
                {/* <Button title='Add Walk-In'><FontAwesomeIcon icon={faTrash}/> Delete Reservation</Button> */}
            </GridToolbar>
            <GridColumn columnType="checkbox" filterable={false} />
            <GridColumn field='ParticipantId' title='Id' />
            <GridColumn field="NameLast" title='Last' media="(min-width: 768px)"/>
            <GridColumn field='NameFirst' title='First' media="(min-width: 768px)"/>
            <GridColumn field='Date' title='Date' filterable={false}/>
            <GridColumn field='StartTime' title='Start Time' filterable={false}/>
            <GridColumn field='Contingent' title='Contingent' media="(min-width: 768px)"/>
            <GridColumn field='CouncilName' title='Council' media="(min-width: 768px)"/>
            <GridColumn field='EventAge' title='Age' filterable={false} media="(min-width: 768px)"/>
            <GridColumn field='Variant' media="(min-width: 768px)"/>
            <GridColumn field='Complete' title='Checked In' width={"150px"} media="(min-width: 768px)"/>
        </Grid>
        </ExcelExport>
        </>    
    )
}


export const ManageRes=({onClose,areaId,areaName,checkIn})=>{
    //Lookup the age by AttendeeID
    const [lotteryComplete,setLotteryComplete]=useState(undefined);
    const [selected, setSelected]=useState(0);
    const [tomorrow,setTomorrow]=useState("");
    const [resetAlert,setResetAlert]=useState(false);

    const getTomorrow = ()=>{
        let tmro = new Date();
        const day1 = new Date(2026,6,23);
        tmro.setDate(tmro.getDate() + 1);
        if (tmro< day1){
             tmro=new Date(day1);
        }
        return (tmro);
    }

    const formatDate=(tmro)=>{
        const year = ''+tmro.getFullYear();
        let month = ''+(tmro.getMonth()+1);
        let day = ''+tmro.getDate();
        if (month.length<2){
            month = "0" +month;
        }
        if (day.length<2){
            day = "0"+day;
        }
        const dtParam = [year,month,day].join("-");
        return dtParam;
    }

    const checkLotteryState = ()=>{
        const tomorrow = getTomorrow();
        if (tomorrow){
            console.log(tomorrow);
            console.log(areaId);
            const dtParam = formatDate(tomorrow);
            const params=new URLSearchParams({area:areaId, date:dtParam});
            const url= "api/index.php/program/getLotteryState?" + params;
            fetch (url,{
                method:"GET"
            }).then(response=>response.json()).then(async data=> {
                console.log(data);
                if (data.length>0){
                    if (data[0]["Complete"]===1){
                        setLotteryComplete(true);
                    }else{
                        setLotteryComplete(false);
                    }                    
                }else{
                    setLotteryComplete(false);
                }
            })
        }
    }

    const updateLotteryState = (state)=>{
        setLotteryComplete(state);
    }
    
  
    const handleSelect = (e) => {
        setSelected(e.selected);
    };

    const showResetAlert=()=>{
        setResetAlert(true);
    }

    const hideResetAlert=()=>{
        setResetAlert(false);
    }

    const resetConfirm=()=>{
        //clear the Lottery for the selected date and area
        console.log("Clear the lottery");
        console.log(tomorrow);
        let lotteryCleared = false
        const params=new URLSearchParams({area:areaId, date:tomorrow});
        const url= "api/index.php/program/clearLottery?" + params;
        fetch (url,{
            method:"GET"
        }).then(response=>response.json()).then(async data=> {
            console.log("Lottery results cleared");
            console.log(data);
            const url= "api/index.php/program/clearLotteryState?" + params;
            fetch (url,{
                method:"GET"
            }).then(response=>response.json()).then(async data=> {
                console.log("Lottery State Reset");
                console.log(data);
                hideResetAlert();
                checkLotteryState();
            })        
        })
    }

    // useEffect=(()=>{
    //     console.log(lotteryComplete);
    // },[lotteryComplete])
 
    useEffect(()=>{
        console.log("Lottery State Changed");
        console.log(lotteryComplete);
        if(lotteryComplete){
            setSelected(1);
        }
    },[lotteryComplete])

    useEffect(()=>{
        console.log("Load Manage Res");
        const tmro=getTomorrow();
        const tmroFmt = formatDate(tmro);
        setTomorrow(tmroFmt);
        checkLotteryState();
    },[])

    return(
        <Dialog title={"Manage Reservations for " + areaName} onClose={onClose} width={"98vw"} height={"98vh"}>
                {resetAlert?<ConfirmDialog onClose={hideResetAlert} onConfirm={resetConfirm} title={"Reset Daily Lottery?"} message={"This will reset the lottery results and allow you to run a new lottery. This cannot be undone. Are you sure you want to proceed?" } type={"WARN"} confirmButtonText={"Yes"} cancelButtonText={"No"}/>:null}
                <TabStrip
                    selected={selected}
                    onSelect={handleSelect}
                >   
                    <TabStripTab title={"Request Queue"}>
                        {lotteryComplete===true?
                            <>
                                <h2>The lottery has already been run for {tomorrow}.</h2>
                                <div><Button onClick={showResetAlert}>Reset Lottery</Button></div>
                            </>:
                            <ReservationQueue areaId={areaId} lotteryState={lotteryComplete} updateLotteryState={updateLotteryState}></ReservationQueue>
                        }
                    </TabStripTab>
                    <TabStripTab title={"Reservations"}>
                        <Reservations areaId={areaId} checkIn={checkIn}></Reservations>
                    </TabStripTab>
                </TabStrip>
        </Dialog>
    )

}